import type { FileRejection } from 'react-dropzone'

/** Single source of truth for both the dropzone `accept` config and its user-facing label. */
export const UPLOAD_ACCEPT = {
  'application/pdf': ['.pdf'],
  'text/csv': ['.txt', '.docx', '.csv'],
}

export const ALLOWED_FILE_TYPES_LABEL = 'PDF, TXT, DOCX, CSV'

/**
 * Human-readable reason for a dropzone rejection. Only `file-invalid-type` is
 * reachable today (neither upload dropzone sets `maxSize`/`maxFiles`), but this
 * stops the message from silently going wrong the moment one of those is added.
 * Uses react-dropzone's stable `ErrorCode` string values directly (not the enum
 * import) so this doesn't break under tests that mock the `react-dropzone` module.
 */
export function describeRejectionReason(rejection: FileRejection): string {
  const code = rejection.errors?.[0]?.code
  switch (code) {
    case 'file-too-large':
      return 'file too large.'
    case 'file-too-small':
      return 'file too small.'
    case 'too-many-files':
      return 'too many files.'
    case 'file-invalid-type':
    default:
      return 'not an allowed file type.'
  }
}
